import {
  Eye,
  MousePointer,
  Send,
  AlertTriangle,
  MessageSquare,
  UserPlus,
  ShieldAlert,
  Edit3,
  X,
  Mail,
  BookOpen,
  Monitor,
} from "lucide-react";
import { colors } from "../../styles/theme";
import { fmtDate } from "../../services/api";

export const TIER_COLORS = {
  hot: { color: "#10b981", bg: "rgba(16,185,129,0.12)", label: "Hot" },
  warm: { color: "#f59e0b", bg: "rgba(245,158,11,0.12)", label: "Warm" },
  cool: { color: "#6366f1", bg: "rgba(99,102,241,0.12)", label: "Cool" },
  cold: { color: "#9ca3b4", bg: "rgba(156,163,180,0.12)", label: "Cold" },
};

export const FREQ_OPTIONS = [
  { value: "all", label: "All emails", color: "#3b82f6" },
  { value: "digest", label: "Monthly digest only", color: "#8b5cf6" },
  { value: "none", label: "No emails", color: "#ef4444" },
];

export const TIMELINE_ICONS = {
  open: { icon: Eye, color: "#3b82f6" },
  click: { icon: MousePointer, color: colors.accent },
  delivered: { icon: Send, color: colors.success },
  bounce: { icon: AlertTriangle, color: colors.danger },
  dropped: { icon: AlertTriangle, color: colors.danger },
  note: { icon: MessageSquare, color: "#8b5cf6" },
  created: { icon: UserPlus, color: colors.textSecondary },
  unsubscribed: { icon: X, color: colors.warning },
  spam_report: { icon: ShieldAlert, color: colors.danger },
  preferences_updated: { icon: Edit3, color: "#3b82f6" },
  deferred: { icon: AlertTriangle, color: colors.warning },
  processed: { icon: Send, color: colors.textSecondary },
  webcast_registered: { icon: BookOpen, color: "#0ea5e9" },
  webcast_attended: { icon: Monitor, color: "#10b981" },
  newsletter_open: { icon: Eye, color: "#f59e0b" },
  newsletter_click: { icon: MousePointer, color: "#f59e0b" },
  email_sent: { icon: Send, color: "#6366f1" },
  email_received: { icon: Mail, color: "#0ea5e9" },
};

export const TIMELINE_FILTERS = [
  { id: "all", label: "All" },
  { id: "webcast", label: "Webcasts" },
  { id: "newsletter", label: "Newsletters" },
  { id: "open", label: "Opens" },
  { id: "click", label: "Clicks" },
  { id: "note", label: "Notes" },
  { id: "email", label: "Emails" },
  { id: "delivered", label: "Delivered" },
  { id: "bounce", label: "Bounces" },
];

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return fmtDate(iso);
}
